import { Exposure, ExposureTrackingProvider } from '@amplitude/experiment-js-client';
import { datadogRum } from '@datadog/browser-rum';
import { analytics } from 'external-libs/segment';

class SegmentExposureTrackingProvider implements ExposureTrackingProvider {
  // eslint-disable-next-line class-methods-use-this
  track(exposure: Exposure) {
    analytics.track('$exposure', exposure);
    // Send the feature flag when Amplitude reports the exposure
    datadogRum.addFeatureFlagEvaluation(exposure.flag_key, exposure.variant);
  }
}

export default SegmentExposureTrackingProvider;
